import React, { Component } from 'react'
import { withTheme } from "@mui/styles";
import Stack from '@mui/material/Stack';
import CustomerPortalRoutes from '../../../routes/CustomerPortalRoutes';
import BaseLayout from '../../../components/customer_portal/layout/BaseLayout';
import { isAuth } from '../../../helpers/cookies';
import { ADMIN, COMPANY_MANAGER, COMPANY_USER, QC } from '../../../helpers/constants';

class CustomerPortalContainer extends Component {
  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const processId = params.get('process_id');
    const stageId = params.get('stage_id');

    if (processId) {
      this.props.setProcessTab(Number(processId));
      this.props.setProcessHasJobForm(Number(processId));
    }

    if (stageId) {
      this.props.setStageTab(Number(stageId));
    }

    if (processId || stageId) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    if (!this.props.company_process || this.props.company_process.length === 0) {
      this.props.get_company_process(isAuth().company_id);
    }
    if (![COMPANY_USER, COMPANY_MANAGER, ADMIN, QC].includes(isAuth().role)) {
      this.props.get_user_company();
    }
    if (!this.props.company_details) {
      this.props.get_company_details_by_domain(window.location.hostname);
    }
  }

  handleChangePasswordOpen = (newVal) => {
    this.props.setChangePasswordOpen(newVal);
  }
  render() {
    const { company_process,
      company_process_stage,
      selected_process_tab,
      selected_stage_tab,
      selected_company,
      change_password,
      is_open,
      company_details
    } = this.props;
    return (
      <Stack sx={{
        height: '100%'
      }}>
        <BaseLayout
          modules={customerPortalModules}
          ChildComponent={CustomerPortalRoutes}
          company_process={company_process}
          company_process_stage={company_process_stage}
          selected_process_tab={selected_process_tab}
          selected_stage_tab={selected_stage_tab}
          selected_company={selected_company}
          change_password={change_password}
          handleChangePasswordOpen={this.handleChangePasswordOpen}
          is_open={is_open}
          company_details={company_details}
        />
      </Stack>
    )
  }
}

export default withTheme(CustomerPortalContainer);

const customerPortalModules = [];